import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { Loading } from '~/shared/Loading';

export function LogoutPage() {
	const { instance } = useMsal();

	useEffect(() => {
		instance.logoutRedirect({
			postLogoutRedirectUri: '/'
		});
	}, [instance]);

	return <Loading message="Logging out..." />;
}
